import BaseReference from '@/types/base/base.reference';
import ReportEmptyReturn from '@/components/imports/reports/ReportEmptyReturn.vue';
import ReportInventory from '@/components/imports/reports/ReportInventory.vue';
import CommissionReport from '@/components/imports/reports/CommissionReport.vue';
import ReportInvoice from '@/components/imports/reports/ReportInvoice.vue';
import WarehouseReport from '@/components/imports/reports/WarehouseReport.vue';
import FlatInvoiceReport from '@/components/imports/reports/FlatInvoiceReport.vue';
import InternalInventory from '@/components/imports/reports/InternalInventoryReport.vue';
import UnfinalizedInventory from '@/components/imports/reports/UnfinalizedInventoryReport.vue';
import CreditMemoAuditReport from '@/components/imports/reports/СreditMemoAuditReport.vue';
import ExportInventoryReport from '@/components/imports/reports/ExportInventoryReport.vue';
import OpenInBondAgingReport from '@/components/imports/reports/charts/OpenInBondAgingReport.vue';
import TransloadStorageReport from '@/components/imports/reports/TransloadStorageReport.vue';
import CustomerInvoicesReport from '@/components/imports/reports/CustomerInvoicesReport.vue';
import TransloadInventoryReport from '@/components/imports/reports/TransloadInventoryReport.vue';
import PendingContainersReport from '@/components/imports/reports/PendingContainersReport.vue';
import IpiAgingReport from '@/components/imports/reports/IpiAgingReport.vue';
import IpiActivityReport from '@/components/imports/reports/IpiActivityReport.vue';
import SummaryActivityReport from '@/components/imports/reports/SummaryActivityReport.vue';
import ReportHold from '@/components/imports/reports/ReportHold.vue';
import MonthlyOriginReport from '@/components/imports/reports/MonthlyOriginReport.vue';
import HblLotKpiReport from '@/components/imports/reports/HblLotKpiReport.vue';
import ReleasedToGOReport from '@/components/imports/reports/ReleasedToGOReport.vue';
import CourierReport from '@/components/imports/reports/CourierReport.vue';
import WindowReleaseReport from '@/components/imports/reports/WindowReleaseReport.vue';
// @ts-ignore
import SalesJournalReport from '@/components/imports/reports/SalesJournalReport.vue';
import {
  PermissionsAccountingReportsFunctions,
  PermissionsAdminReportsFunctions,
  PermissionsExportReportsFunctions,
  PermissionsImportReportsFunctions,
  PermissionsIpiReportsFunctions,
} from '@/constants/permissions';
import MblLotKpiReport from '@/components/imports/reports/MblLotKpiReport.vue';
import IpiWeeklyBillingReport from '@/components/imports/reports/IpiWeeklyBillingReport.vue';

export const REPORTS_TABS = {
  // ACCOUNTING REPORTS
  CreditMemoAuditReport: 'CREDIT_MEMO_AUDIT_REPORT',
  CommissionReport: 'COMMISSION_REPORT',
  InvoiceReport: 'INVOICE_REPORT',
  WarehouseReport: 'WAREHOUSE_REPORT',
  UnInvoiced: 'UNINVOICED',
  TransloadStorage: 'TRANSLOAD_STORAGE_REPORT',
  CustomerInvoices: 'CUSTOMER_INVOICES',
  CourierReport: 'COURIER_REPORT',
  FlatInvoiceReport: 'FLAT_INVOICE_REPORT',
  FlatInvoice: 'FLAT_INVOICE',
  SalesJournal: 'SALES_JOURNAL',
  IpiWeeklyBilling: 'IPI_WEEKLY_BILLING',
  // ADMIN REPORTS
  SummaryActivity: 'SUMMARY_ACTIVITY',
  EmptyReturnReport: 'UNIT_INVENTORY_REPORT',
  InternalInventory: 'INTERNAL_INVENTORY_REPORT',
  UnfinalizedInventory: 'UNFINALIZED_REPORT',
  MonthlyOrigin: 'MONTHLY_ORIGIN',

  // EXPORT REPORTS
  ExportInventoryReport: 'EXPORT_INVENTORY_REPORT',

  // IMPORT REPORT
  OpenInBondAging: 'OPEN_IN_BOND_AGING',
  ImportInventory: 'IMPORT_INVENTORY',
  PendingContainers: 'PENDING_CONTAINERS',
  TransloadInventory: 'TRANSLOAD_INVENTORY_REPORT',
  HoldByCustomer: 'HOLD_BY_CUSTOMER',
  HblLotKpi: 'HBL_LOT_KPI',
  MblLotKpi: 'MBL_LOT_KPI',
  ReleasedToGo: 'RELEASED_TO_GO',
  WindowRelease: 'WINDOW_RELEASE',

  // IPI REPORTS
  IpiAging: 'IPI_AGING',
  IpiActivity: 'IPI_ACTIVITY',
};

export const EXPORT_REPORT_TABS = [
  {
    text: 'Export Inventory',
    value: REPORTS_TABS.ExportInventoryReport,
    permission: PermissionsExportReportsFunctions.EXPORT_INVENTORY,
    component: ExportInventoryReport,
  },
];

export const IPI_REPORT_TABS = [
  {
    text: 'IPI Aging',
    value: REPORTS_TABS.IpiAging,
    permission: PermissionsIpiReportsFunctions.IPI_AGING,
    component: IpiAgingReport,
  },
  {
    text: 'IPI Activity',
    value: REPORTS_TABS.IpiActivity,
    permission: PermissionsIpiReportsFunctions.IPI_ACTIVITY,
    component: IpiActivityReport,
  },
];

export const ADMIN_REPORT_TABS = [
  {
    text: 'Monthly Origin',
    value: REPORTS_TABS.MonthlyOrigin,
    permission: PermissionsAdminReportsFunctions.MONTHLY_ORIGIN,
    component: MonthlyOriginReport,
  },
  {
    text: 'Unit Inventory',
    value: REPORTS_TABS.EmptyReturnReport,
    permission: PermissionsAdminReportsFunctions.UNIT_INVENTORY,
    component: ReportEmptyReturn,
  },
  {
    text: 'Summary Activity',
    value: REPORTS_TABS.SummaryActivity,
    permission: PermissionsAdminReportsFunctions.SUMMARY_ACTIVITY,
    component: SummaryActivityReport,
  },
  {
    text: 'Internal Inventory',
    value: REPORTS_TABS.InternalInventory,
    permission: PermissionsAdminReportsFunctions.INVENTORY_INTERNAL,
    component: InternalInventory,
  },
  {
    text: 'Unfinalized',
    value: REPORTS_TABS.UnfinalizedInventory,
    permission: PermissionsAdminReportsFunctions.UNFINALIZED,
    component: UnfinalizedInventory,
  },
];

export const ACCOUNTING_REPORT_TABS = [
  {
    text: 'Credit Memo Audit',
    value: REPORTS_TABS.CreditMemoAuditReport,
    permission: PermissionsAccountingReportsFunctions.CREDIT_MEMO_AUDIT,
    component: CreditMemoAuditReport,
  },
  {
    text: 'Courier',
    value: REPORTS_TABS.CourierReport,
    permission: PermissionsAccountingReportsFunctions.COURIER,
    component: CourierReport,
  },
  {
    text: 'Commission',
    value: REPORTS_TABS.CommissionReport,
    permission: PermissionsAccountingReportsFunctions.COMMISSION,
    component: CommissionReport,
  },
  {
    text: 'Invoice',
    value: REPORTS_TABS.InvoiceReport,
    permission: PermissionsAccountingReportsFunctions.INVOICE,
    component: ReportInvoice,
  },
  {
    text: 'Warehouse Collect',
    value: REPORTS_TABS.WarehouseReport,
    permission: PermissionsAccountingReportsFunctions.WAREHOUSE_COLLECT,
    component: WarehouseReport,
  },
  {
    text: 'Flat Invoice',
    value: REPORTS_TABS.FlatInvoiceReport,
    permission: PermissionsAccountingReportsFunctions.FLAT_INVOICE,
    component: FlatInvoiceReport,
  },
  // {
  //   text: 'Uninvoiced',
  //   value: REPORTS_TABS.UnInvoiced,
  //   permission: PermissionsAccountingReportsFunctions.UNINVOICED,
  //   component: UnInvoicedReport,
  // },
  {
    text: 'Transload Storage',
    value: REPORTS_TABS.TransloadStorage,
    permission: PermissionsAccountingReportsFunctions.TRANSLOAD_STORAGE,
    component: TransloadStorageReport,
  },
  {
    text: 'Customer Invoices',
    value: REPORTS_TABS.CustomerInvoices,
    permission: PermissionsAccountingReportsFunctions.CUSTOMER_INVOICES,
    component: CustomerInvoicesReport,
  },
  {
    text: 'Sales Journal',
    value: REPORTS_TABS.SalesJournal,
    permission: PermissionsAccountingReportsFunctions.SALES_JOURNAL,
    component: SalesJournalReport,
  },
  {
    text: 'IPI Weekly Billing',
    value: REPORTS_TABS.IpiWeeklyBilling,
    permission: PermissionsAccountingReportsFunctions.IPI_WEEKLY_BILLING,
    component: IpiWeeklyBillingReport,
  },
];

export const IMPORT_REPORT_TABS = [
  {
    text: 'Hold By Customer',
    value: REPORTS_TABS.HoldByCustomer,
    permission: PermissionsImportReportsFunctions.HOLD_BY_CUSTOMER,
    component: ReportHold,
  },
  {
    text: 'Import Inventory',
    value: REPORTS_TABS.ImportInventory,
    permission: PermissionsImportReportsFunctions.IMPORT_INVENTORY,
    component: ReportInventory,
  },
  {
    text: 'Open In Bond Aging',
    value: REPORTS_TABS.OpenInBondAging,
    permission: PermissionsImportReportsFunctions.OPEN_INBOND_AGING,
    component: OpenInBondAgingReport,
  },
  {
    text: 'Transload Inventory',
    value: REPORTS_TABS.TransloadInventory,
    permission: PermissionsImportReportsFunctions.TRANSLOAD_INVENTORY,
    component: TransloadInventoryReport,
  },
  {
    text: 'HBL LOT KPI',
    value: REPORTS_TABS.HblLotKpi,
    permission: PermissionsImportReportsFunctions.HBL_LOT_KPI,
    component: HblLotKpiReport,
  },
  {
    text: 'MBL LOT KPI',
    value: REPORTS_TABS.MblLotKpi,
    permission: PermissionsImportReportsFunctions.MBL_LOT_KPI,
    component: MblLotKpiReport,
  },
  {
    text: 'Pending Containers',
    value: REPORTS_TABS.PendingContainers,
    permission: PermissionsImportReportsFunctions.PENDING_CONTAINERS,
    component: PendingContainersReport,
  },
  {
    text: 'Released to General Order',
    value: REPORTS_TABS.ReleasedToGo,
    permission: PermissionsImportReportsFunctions.RELEASED_TO_GO,
    component: ReleasedToGOReport,
  },
  {
    text: 'Window Release',
    value: REPORTS_TABS.WindowRelease,
    permission: PermissionsImportReportsFunctions.WINDOW_RELEASE,
    component: WindowReleaseReport,
  },
];

export enum DocumentTypes {
  IMPORT_TRANSLOAD = 'importtransload',
  IMPORT_LOADGUIDE = 'importloadguide',
  EXPORT_LOADGUIDE = 'exportloadguide',
  INVENTORY = 'inventory',
  CREDIT_MEMO_AUDIT = 'creditmemoaudit',
  TRANSLOAD_STORAGE = 'transloadstorage',
  CUSTOMER_INVOICES = 'customerinvoices',
  TRANSLOAD_INVENTORY = 'transloadinventory',
  EXPORT_INVENTORY = 'exportinventory',
  IPI_ACTIVITY = 'ipiactivity',
  IPI_AGING = 'ipiaging',
  OPEN_IN_BOND_AGING = 'openinbondaging',
  SUMMARY_ACTIVITY = 'summaryactivity',
  UNINVOICED = 'uninvoiced',
  MONTHLY_ORIGIN_IMPORT = 'monthlyoriginimport',
  MONTHLY_ORIGIN_EXPORT = 'monthlyoriginexport',
  SALES_JOURNAL = 'salesournal',
}

export const MONTHLY_ORIGIN_REPORT_DOCUMENT_TYPE_OPTION: Partial<
  Record<DocumentTypes, BaseReference>
> = {
  [DocumentTypes.MONTHLY_ORIGIN_IMPORT]: {
    description: 'Import Monthly Origin',
    code: DocumentTypes.MONTHLY_ORIGIN_IMPORT,
  },
  [DocumentTypes.MONTHLY_ORIGIN_EXPORT]: {
    description: 'Export Monthly Origin',
    code: DocumentTypes.MONTHLY_ORIGIN_EXPORT,
  },
};

export const UNFINALIZED_REPORT_DOCUMENT_TYPE_OPTION: Partial<
  Record<DocumentTypes, BaseReference>
> = {
  [DocumentTypes.IMPORT_TRANSLOAD]: {
    description: 'Import CFS and Transload',
    code: DocumentTypes.IMPORT_TRANSLOAD,
  },
  [DocumentTypes.IMPORT_LOADGUIDE]: {
    description: 'IPI Load Guide',
    code: DocumentTypes.IMPORT_LOADGUIDE,
  },
  [DocumentTypes.EXPORT_LOADGUIDE]: {
    description: 'Export Load Guide',
    code: DocumentTypes.EXPORT_LOADGUIDE,
  },
};
export const UNFINALIZED_REPORT_DOCUMENT_TYPE_OPTIONS = Object.values(
  UNFINALIZED_REPORT_DOCUMENT_TYPE_OPTION
);

export enum OutputTypes {
  XLSX = 'xlsx',
  PDF = 'pdf',
  DOCX = 'docx',
}

export enum DatePeriods {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
}

export const DatePeriodsOptions = Object.values(DatePeriods);
